import React, { Fragment, useState } from "react";
import lightBlue from "@material-ui/core/colors/lightBlue";

import DateFnsUtils from '@date-io/date-fns';
import { KeyboardTimePicker, DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import { IconButton, makeStyles, Popper, TextField } from "@material-ui/core";
import { IoMdTime } from 'react-icons/io';
import { IconContext } from "react-icons";
import { theme } from "../../theme/theme"
import { ThemeProvider } from "styled-components";
import { createMuiTheme } from "@material-ui/core";
import moment from "moment";

const useStyles = makeStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    color: theme.palette.text.header,
    '& .MuiPickersCalendarHeader-transitionContainer': {
      width: '120px',
    },
    '&::-webkit-calendar-picker-indicator': {
        filter: 'invert(1)',
    },
  },
  square: {
    background: theme.palette.primary.main,
    color: '#587578',
    borderRadius: '5px',
    padding: '6px',
  },
  squareRed: {
    background: theme.palette.secondary.main,
    color: '#587578',
    borderRadius: '5px',
    padding: '6px',
  },
  button: {
      background: 'none',
      color: theme.palette.text.primary,
  },
  okButton: {
    background: theme.palette.primary.main,
    color: theme.palette.text.header,
  },
  input: {
        marginTop: theme.spacing(0),
        border: '1px solid',
        borderColor: theme.palette.secondary.main,
        borderRadius: theme.shape.borderRadius,
        backgroundColor: theme.palette.secondary.dark,
        padding: '10px 26px 10px 12px',
        position: 'relative',
        textDecoration: 'none',
        width: '340px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
        '&:focus, &:hover, &:active, &:focus-visible, &:focus-within': {
            border: 'collapse',
            borderColor: 'transparent',
            backgroundColor: theme.palette.secondary.dark,
            borderRadius: theme.shape.borderRadius,
        },
  },
  inputText:{
    color: 'white',
    fontSize: '1.125rem',
  },
  underline: {
    "&&&:before": {
      borderBottom: "none"
    },
    "&&:after": {
      borderBottom: "none"
    }
  }
});

const ModalProps = {
    PaperProps: {
        style: {
            backgroundColor: '#28353D',
            color: '#fff',
        }
    },
}

const InputTimePicker = (props) => {
  const classes = useStyles();
  const [isOpen, setIsOpen] = useState(false);
  const [selectedDate, handleDateChange] = useState(new Date());


  const handleDateSelect = (date) => {
    console.log(date)
    handleDateChange(date)
    props.onDatechange(moment(date).format("HH:mm"));
  }
  return (
      <ThemeProvider theme={theme}>
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <div className={classes.root}>
        <KeyboardTimePicker
            ampm={false}
            variant="dialog"
            openTo="hours"
            keyboardIcon={<IoMdTime/>}
            margin="normal"
            id="time-picker-inline"
            disableToolbar
            value={selectedDate}
            maxDate={new Date()}
            onChange={handleDateSelect}
            // onBlur={handleDateChange}
            // inputProps={...inputProps}
            InputProps={{
              disableUnderline:true,
              classes: {
                input: classes.inputText,
              }
            }}
            DialogProps={ModalProps}
            leftArrowButtonProps={{classes: {root: classes.button}}}
            rightArrowButtonProps={{classes: {root: classes.button}}}
            className={classes.input}
            // KeyboardButtonProps={{
            //     'aria-label': 'change time',
            //     'type': 'contained'
            // }}
        />

        {/* <DatePicker
            variant="dialog"
            view="month"
            open={isOpen}
            onOpen={() => setIsOpen(true)}
            onClose={() => setIsOpen(false)}
            format="d MMM yyyy"
            value={selectedDate}
            onChange={handleDateChange}
            maxDateMessage={new Date()}
            // TextFieldComponent={() => null}
            disableToolbar
            DialogProps={ModalProps}
            leftArrowButtonProps={{classes: {root: classes.button}}}
            rightArrowButtonProps={{classes: {root: classes.button}}}
            inputVariant="filled"
            className={color === 'secondary'? 'secondary' : ''}
        /> */}
        </div>
     </MuiPickersUtilsProvider>
     </ThemeProvider>
  );
}

export default InputTimePicker;
